import React from "react";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import { HomeWrapper } from "./Login";

const ThankQ = () => {
  const history = useHistory();
  const location = useLocation();

  return (
    <HomeWrapper>
      <form className="flex-center">
        <div>
          <div className="head-sec">
            <h3 className="text-heading">{location?.state?.from === "reset_password" ? "Password Changed!" : "Reset your password"}</h3>
            <span className="text-sub-heading mt1 mb1 w60">{location?.state?.from === "reset_password" ? <>
              Your password has been changed successfully.
            </> : <>
              Check your inbox, we just sent you an email at {" "}
              {location?.state?.email}
            </>}
            </span>
          </div>

          <div className="v-center mt2">
            <span
              className="p-link "
              onClick={() => {
                history.push("/");
              }}
            >
              Back to login
            </span>
          </div>
        </div>
      </form>
    </HomeWrapper>
  );
};

export default ThankQ;
